/**
 * Operation module translations - English
 * Includes: opening preparation, sales data management, site management, dashboard
 */
export default {
  operation: {
    // Opening Preparation Management
    renovation: {
      title: 'Opening Preparation',
      // Stat cards
      statPendingEntry: 'Pending Entry',
      statPendingReview: 'Pending Review',
      statReviewRejected: 'Review Rejected',
      statReviewApproved: 'Review Approved',
      statRenovating: 'Renovating',
      statPendingOpening: 'Pending Opening',
      statOpened: 'Opened',
      statEntryAndReview: 'Entry & Review',
      // Search form
      keyword: 'Keyword',
      keywordPlaceholder: 'Merchant / brand / shop / contract no.',
      renovationStatus: 'Status',
      newApplication: 'New Application',
      hideSearch: 'Hide Search',
      showSearch: 'Show Search',
      // Table columns
      shopName: 'Asset',
      merchantName: 'Merchant',
      brandName: 'Brand',
      contractNo: 'Contract No.',
      applyDate: 'Apply Date',
      plannedConstructionPeriod: 'Planned Period',
      renovationManagerCol: 'Contact',
      merchantContactTag: 'Merchant',
      currentStatus: 'Current Status',
      // Status options
      statusPendingEntry: 'Pending Entry',
      statusPendingReview: 'Pending Review',
      statusReviewRejected: 'Review Rejected',
      statusReviewApproved: 'Review Approved',
      statusRenovating: 'Renovating',
      statusPendingOpening: 'Pending Opening',
      statusOpened: 'Opened',
      // Action buttons
      submitBlueprint: 'Submit Blueprint',
      resubmitBlueprint: 'Resubmit',
      reviewBlueprint: 'Review Blueprint',
      approveEntry: 'Approve Entry',
      completeAccept: 'Complete & Accept',
      confirmOpening: 'Confirm Opening',
      // Dialog titles
      addTitle: 'New Opening Preparation',
      editTitle: 'Edit Opening Preparation',
      detailTitle: 'Preparation Details',
      submitBlueprintTitle: 'Submit Blueprint',
      resubmitBlueprintTitle: 'Resubmit Blueprint',
      reviewBlueprintTitle: 'Review Blueprint',
      entryTitle: 'Approve Entry',
      acceptTitle: 'Completion Acceptance',
      openingTitle: 'Confirm Opening',
      // Form fields
      shop: 'Shop',
      shopPlaceholder: 'Select shop',
      relatedContract: 'Contract',
      contractPlaceholder: 'Select contract',
      merchant: 'Merchant',
      merchantAutoFill: 'Auto-filled after shop selection',
      brand: 'Brand',
      plannedDateRange: 'Planned Period',
      plannedStartPlaceholder: 'Start date',
      plannedEndPlaceholder: 'End date',
      dateTo: 'to',
      renovationDescription: 'Description',
      renovationDescriptionPlaceholder: 'Enter renovation description',
      // Entry form
      renovationManager: 'Renovation Manager',
      renovationManagerPlaceholder: 'Enter renovation manager name',
      renovationManagerPhone: 'Manager Phone',
      renovationManagerPhonePlaceholder: 'Enter manager phone',
      entryPlannedDateRange: 'Planned Renovation Period',
      // Acceptance form
      acceptResult: 'Result',
      acceptResultPassed: 'Passed',
      acceptResultFailed: 'Failed',
      acceptRemarkLabel: 'Remark',
      acceptRemarkPlaceholder: 'Enter acceptance remark',
      acceptResultRequired: 'Please select acceptance result',
      rejectReason: 'Reject Reason',
      rejectReasonPlaceholder: 'Enter reject reason',
      rejectReasonRequired: 'Reject reason is required when acceptance fails',
      renovationCompany: 'Renovation Company',
      renovationCompanyPlaceholder: 'Enter renovation company name',
      // Opening confirmation form
      openingDate: 'Opening Date',
      openingDatePlaceholder: 'Select opening date',
      openingDateRequired: 'Please select opening date',
      // New application enhanced fields
      renovationType: 'Renovation Type',
      renovationTypePlaceholder: 'Select renovation type',
      renovationTypeRequired: 'Please select renovation type',
      typeStandard: 'Standard',
      typeSimple: 'Simple Refresh',
      typeMajor: 'Major Renovation',
      renovationBudget: 'Budget (10K)',
      renovationBudgetPlaceholder: 'Enter renovation budget',
      merchantContactLabel: 'Merchant Contact',
      merchantContactPlaceholder: 'Enter merchant contact name',
      merchantContactRequired: 'Please enter merchant contact',
      merchantContactPhone: 'Contact Phone',
      merchantContactPhonePlaceholder: 'Enter merchant contact phone',
      merchantContactPhoneRequired: 'Please enter contact phone',
      // Entry enhanced fields
      constructionPermit: 'Construction Permit No.',
      constructionPermitPlaceholder: 'Enter construction permit number',
      entryNoticeConfirmed: 'Entry Notice',
      entryNoticeLabel: 'Merchant has been informed of renovation rules and safety notice',
      entryNoticeRequired: 'Please confirm entry notice has been delivered',
      entryRemark: 'Entry Remark',
      entryRemarkPlaceholder: 'Enter special instructions',
      // Fee management
      feeTitle: 'Renovation Fees',
      feeItem: 'Fee Item',
      feeItemPlaceholder: 'Select or enter fee name',
      feeAmount: 'Amount',
      feeAmountPlaceholder: 'Enter amount',
      feeRefundable: 'Refundable',
      feeRemark: 'Remark',
      feeAdd: 'Add Fee',
      feeSaveSuccess: 'Fees saved successfully',
      feeAmountTotal: 'Total Amount',
      feePaymentStatus: 'Payment Status',
      feePaidAmount: 'Paid Amount',
      // Construction progress
      progressTitle: 'Construction Progress',
      progressUpdate: 'Update Progress',
      progressUpdateTitle: 'Update Construction Progress',
      progressStage: 'Progress Stage',
      progressStagePlaceholder: 'Select current stage',
      progressStageRequired: 'Please select progress stage',
      stagePreparation: 'Preparation',
      stageConstruction: 'Construction',
      stageFinishing: 'Finishing',
      stageSelfCheck: 'Self-Check',
      progressDescription: 'Description',
      progressDescriptionPlaceholder: 'Enter progress description',
      progressSuccess: 'Progress record added',
      // Rectification
      rectificationTitle: 'Send Rectification Notice',
      rectificationSend: 'Send Rectification Notice',
      rectificationIssue: 'Issue',
      rectificationIssuePlaceholder: 'Describe the issue to rectify',
      rectificationIssueRequired: 'Please enter the issue',
      rectificationDeadline: 'Deadline',
      rectificationDeadlinePlaceholder: 'Select deadline',
      rectificationDeadlineRequired: 'Please select deadline',
      rectificationSuccess: 'Rectification notice sent',
      // Acceptance enhanced
      acceptanceChecklist: 'Acceptance Checklist',
      checkAppearance: 'Shop Appearance & Signage',
      checkAppearanceDesc: 'Meets mall unified standards',
      checkUtility: 'Utility Connections',
      checkUtilityDesc: 'Water/electric/gas connections are standard',
      checkFireSafety: 'Fire Safety',
      checkFireSafetyDesc: 'Smoke detectors, sprinklers, extinguishers, exit signs',
      checkSafetyEnv: 'Safety & Environment',
      checkSafetyEnvDesc: 'Exits clear, materials compliant, no hazards',
      checkCleaning: 'Cleanliness',
      checkCleaningDesc: 'Construction waste cleared, shop clean',
      checkAllRequired: 'All checklist items must pass for approval',
      // Opening enhanced
      licenseChecklist: 'License Verification',
      licenseBusiness: 'Business License',
      licenseBusinessDesc: 'Obtained or filed',
      licenseFire: 'Fire Acceptance',
      licenseFireDesc: 'Fire department approved or filed',
      licenseHealth: 'Health Permit',
      licenseHealthDesc: 'Required for food/catering businesses',
      licenseBusinessRequired: 'Business license must be confirmed',
      openingRemarkLabel: 'Opening Remark',
      openingRemarkPlaceholder: 'Enter special notes',
      // Shop-contract cascading hints
      noActiveContract: 'No active contract for this shop',
      contractAutoFill: 'Auto-matched after selecting shop',
      loadingContract: 'Loading contract...',
      // Validation
      shopRequired: 'Please select a shop',
      contractRequired: 'Please select a contract',
      // Detail page
      processProgress: 'Process Progress',
      basicInfo: 'Basic Information',
      renovationInfo: 'Renovation Information',
      plannedStartDate: 'Planned Start',
      plannedEndDate: 'Planned End',
      actualStartDate: 'Actual Start',
      actualEndDate: 'Actual End',
      acceptRemark: 'Acceptance Remark',
      // Blueprint review fields
      blueprintAttachments: 'Blueprint Files',
      blueprintAttachmentsPlaceholder: 'Upload renovation blueprints (PDF/DWG/JPG/PNG)',
      blueprintAttachmentsRequired: 'Please upload blueprint files',
      blueprintAttachmentsTip: 'Supports PDF, DWG, JPG, PNG. Max 50MB per file.',
      blueprintReviewResult: 'Review Result',
      blueprintApproved: 'Approved',
      blueprintRejected: 'Rejected',
      blueprintRejectReason: 'Reject Reason',
      blueprintRejectReasonPlaceholder: 'Enter reject reason',
      blueprintRejectReasonRequired: 'Reject reason is required when review fails',
      blueprintReviewRemark: 'Review Remark',
      blueprintReviewRemarkPlaceholder: 'Enter review remark (optional)',
      blueprintSubmitSuccess: 'Blueprint submitted successfully',
      blueprintApproveSuccess: 'Blueprint review approved',
      blueprintRejectSuccess: 'Blueprint review rejected',
      blueprintResultRequired: 'Please select review result',
      blueprintInfo: 'Blueprint Review Info',
      blueprintSubmitDate: 'Submit Date',
      blueprintSubmitBy: 'Submitted By',
      blueprintSubmissionCount: 'Submission Count',
      blueprintReviewDate: 'Review Date',
      blueprintReviewBy: 'Reviewed By',
      blueprintViewFiles: 'View Files',
      blueprintDownload: 'Download',
      blueprintNoFiles: 'No files',
      blueprintTimesUnit: ' time(s)',
      // Timeline nodes
      nodePendingEntry: 'Pending Entry',
      nodePendingReview: 'Pending Review',
      nodeReviewApproved: 'Review Approved',
      nodeRenovating: 'Renovating',
      nodePendingOpening: 'Pending Opening',
      nodeOpened: 'Opened',
      // Confirm messages
      deleteConfirm: 'Are you sure to delete this record?',
      deleteWarning: 'Warning',
      entryConfirmMsg: 'Confirm approving entry for renovation?',
      entryConfirmTitle: 'Approve Entry',
      openingConfirmMsg: 'Confirm this merchant has officially opened? This will update the contract opening date and asset status.',
      openingConfirmTitle: 'Confirm Opening',
      // Success messages
      updateSuccess: 'Updated successfully',
      submitSuccess: 'Application submitted successfully',
      entrySuccess: 'Entry approved',
      acceptSuccess: 'Acceptance submitted successfully',
      openingSuccess: 'Opening confirmed',
    },
    // Sales Data Management
    sales: {
      title: 'Sales Data Management',
      // Stat cards
      statPending: 'Pending',
      statApproved: 'Approved',
      statRejected: 'Rejected',
      statUnreported: 'Unreported',
      // Search form
      keyword: 'Keyword',
      keywordPlaceholder: 'Merchant / shop / contract no.',
      reportMonth: 'Report Month',
      reportMonthPlaceholder: 'Select month',
      auditStatus: 'Audit Status',
      reportType: 'Report Type',
      reportTypePlaceholder: 'Select report type',
      reportTypeMerchantSelf: 'Merchant Self-report',
      reportTypeOperationProxy: 'Ops Proxy',
      reportTypeDiffAdjust: 'Difference Adjustment',
      reportTypeSystemImport: 'System Import',
      dataSource: 'Data Source',
      sourceManual: 'Manual Entry',
      sourcePosSync: 'POS Sales',
      sourceImport: 'File Import',
      // Table columns
      merchantName: 'Merchant',
      shopName: 'Asset',
      contractNo: 'Contract No.',
      reportMonthCol: 'Report Month',
      salesAmount: 'Sales Amount',
      reportedBy: 'Reported By',
      reportTime: 'Report Time',
      reviewer: 'Reviewer',
      reviewTime: 'Review Time',
      rejectReason: 'Reject Reason',
      // Status options
      statusPending: 'Pending',
      statusApproved: 'Approved',
      statusRejected: 'Rejected',
      // Action buttons
      addReport: 'Add Report',
      batchApprove: 'Batch Approve',
      exportData: 'Export',
      approve: 'Approve',
      reject: 'Reject',
      withdraw: 'Withdraw',
      // Dialog titles
      addTitle: 'New Sales Report',
      editTitle: 'Edit Sales Report',
      detailTitle: 'Report Details',
      rejectTitle: 'Reject Report',
      // Form fields
      merchant: 'Merchant',
      merchantPlaceholder: 'Select merchant',
      shop: 'Shop',
      shopPlaceholder: 'Select shop',
      brand: 'Brand',
      contract: 'Contract',
      contractPlaceholder: 'Search by merchant/brand/shop',
      salesAmountLabel: 'Sales Amount',
      salesAmountPlaceholder: 'Enter sales amount',
      remarkLabel: 'Remark',
      remarkPlaceholder: 'Enter remark',
      rejectReasonLabel: 'Reject Reason',
      rejectReasonPlaceholder: 'Enter reject reason',
      // Validation
      contractRequired: 'Please select a contract',
      reportMonthRequired: 'Please select report month',
      salesAmountRequired: 'Please enter sales amount',
      rejectReasonRequired: 'Please enter reject reason',
      // Confirm messages
      approveConfirm: 'Are you sure to approve this report?',
      approveConfirmTitle: 'Confirm Approval',
      batchApproveConfirm: 'Are you sure to batch approve {count} selected records?',
      batchApproveConfirmTitle: 'Batch Approval',
      withdrawConfirm: 'Are you sure to withdraw this report?',
      withdrawConfirmTitle: 'Confirm Withdrawal',
      deleteConfirm: 'Are you sure to delete this report?',
      deleteWarning: 'Warning',
      // Success messages
      submitSuccess: 'Report submitted successfully',
      updateSuccess: 'Updated successfully',
      approveSuccess: 'Approved',
      rejectSuccess: 'Rejected',
      batchApproveSuccess: 'Batch approved successfully',
      withdrawSuccess: 'Withdrawn',
      // Tips
      selectRecords: 'Please select records to operate',
      onlyPendingCanBatchApprove: 'Only pending records can be batch approved',
      // Period type
      periodType: 'Period Type',
      periodTypeDaily: 'Daily',
      periodTypeMonthly: 'Monthly',
      reportDate: 'Report Date',
      attachments: 'Sales Receipts',
      // V2: Business type
      tabAll: 'All',
      tabRental: 'Rental',
      tabJoint: 'Joint',
      tabSelfOperated: 'Self-operated',
      businessType: 'Business Type',
      businessTypeRental: 'Rental',
      businessTypeJoint: 'Joint',
      businessTypeSelfOperated: 'Self-operated',
      transactionNo: 'Transaction No.',
      transactionTime: 'Transaction Time',
      totalAmount: 'Total Amount',
      originalAmount: 'Original Amount',
      discountAmount: 'Discount Amount',
      totalQuantity: 'Total Qty',
      // V2: Form mode
      switchToDetail: 'Switch to Detail Mode',
      backToSimple: 'Back to Simple Mode',
      detailMode: 'Detail Mode',
      simpleMode: 'Simple Mode',
      // V2: Items
      itemSection: 'Product Items',
      addProductRow: 'Add Product',
      productName: 'Product Name',
      skuCode: 'SKU Code',
      unitPrice: 'Unit Price',
      quantity: 'Quantity',
      discountRate: 'Discount(%)',
      discountAmountCol: 'Discount',
      subtotal: 'Subtotal',
      itemProductRequired: 'Please select product',
      itemPriceRequired: 'Please enter unit price',
      itemQuantityRequired: 'Please enter quantity',
      // V2: Terminal No
      terminalNo: 'Terminal No.',
      terminalNoPlaceholder: 'Enter terminal number',
      // V2: Receipt
      receiptLabel: 'Receipt',
      uploadReceipt: 'Upload',
      noReceipt: 'No receipt',
      // V2: Payments
      paymentSection: 'Payment Methods',
      paymentMismatch: 'Payment total does not match total amount',
      paymentTotal: 'Payment Total',
      // V2: Remark
      remarkLabel: 'Remark',
      remarkPlaceholder: 'Enter remark',
      // Batch import
      importSales: 'Batch Import',
      importStep1: 'Download Template',
      importStep2: 'Upload File',
      importStep3: 'Validate Results',
      importStep4: 'Complete',
      downloadTemplate: 'Download Import Template',
      selectFile: 'Select File',
      validating: 'Validating...',
      importResult: 'Import Results',
      validRows: 'Valid Rows',
      invalidRows: 'Error Rows',
      confirmImport: 'Confirm Import',
      importSuccess: 'Import Successful',
      importFailed: 'Import Failed',
      viewErrors: 'View Errors',
    },
    // Site management
    site: {
      title: 'Site Management',
      underDevelopment: 'Under development...',
    },
    // Utility Management
    utility: {
      title: 'Utility Management',
      meter: {
        title: 'Meter Ledger',
        addMeter: 'Add Meter',
        editMeter: 'Edit Meter',
        detailMeter: 'Meter Details',
        replaceMeter: 'Replace Meter',
        bindContract: 'Bind Contract',
        meterCode: 'Meter Code',
        meterCodePlaceholder: 'Enter meter code',
        meterName: 'Meter Name',
        meterNamePlaceholder: 'Enter meter name',
        meterType: 'Meter Type',
        meterTypePlaceholder: 'Select meter type',
        typeWater: 'Water',
        typeElectric: 'Electric',
        typeGas: 'Gas',
        meterUsage: 'Usage',
        meterUsagePlaceholder: 'Select usage',
        usagePrivate: 'Private',
        usagePublic: 'Public',
        shop: 'Shop',
        shopPlaceholder: 'Select shop',
        contract: 'Contract',
        contractPlaceholder: 'Select contract',
        merchant: 'Merchant',
        building: 'Building',
        buildingPlaceholder: 'Select building',
        floor: 'Floor',
        floorPlaceholder: 'Select floor',
        multiplier: 'Multiplier',
        multiplierPlaceholder: 'Enter multiplier',
        initialReading: 'Initial Reading',
        initialReadingPlaceholder: 'Enter initial reading',
        unitPrice: 'Unit Price',
        unit: 'Unit',
        unitPlaceholder: 'Enter unit',
        shareMethod: 'Share Method',
        shareMethodPlaceholder: 'Select share method',
        shareByArea: 'By Area',
        shareByUsage: 'By Usage',
        shareEqual: 'Equal',
        shareScope: 'Share Scope',
        shareScopePlaceholder: 'Share scope (building/floor)',
        status: 'Status',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        statusScrapped: 'Scrapped',
        installDate: 'Install Date',
        installDatePlaceholder: 'Select install date',
        lastReading: 'Last Reading',
        lastReadingMonth: 'Last Reading Month',
        replaceTitle: 'Replace Meter',
        finalReading: 'Final Reading (Old)',
        finalReadingPlaceholder: 'Enter old meter final reading',
        newMeterCode: 'New Meter Code',
        newMeterCodePlaceholder: 'Enter new meter code',
        newInitialReading: 'New Initial Reading',
        newInitialReadingPlaceholder: 'Enter new meter initial reading',
        replaceSuccess: 'Meter replaced successfully',
        replaceConfirm: 'Confirm replace? Old meter will be scrapped.',
        meterCodeRequired: 'Please enter meter code',
        meterNameRequired: 'Please enter meter name',
        meterTypeRequired: 'Please select meter type',
        meterUsageRequired: 'Please select usage',
        shopRequired: 'Private meter requires a shop',
        createSuccess: 'Meter created successfully',
        updateSuccess: 'Meter updated successfully',
        deleteConfirm: 'Are you sure to delete this meter?',
        deleteSuccess: 'Meter deleted successfully',
        bindSuccess: 'Contract bound successfully',
        keyword: 'Keyword',
        keywordPlaceholder: 'Meter code/name/shop/merchant',
      },
      reading: {
        title: 'Meter Reading',
        addReading: 'Add Reading',
        batchSubmit: 'Batch Submit',
        batchConfirm: 'Batch Confirm',
        batchGenerateFee: 'Batch Generate Fee',
        importReading: 'Import Readings',
        exportData: 'Export',
        statPending: 'Pending',
        statConfirmed: 'Confirmed',
        statFeeGenerated: 'Fee Generated',
        statAbnormal: 'Abnormal',
        statTotalUsage: 'Total Usage',
        statTotalFee: 'Total Fee',
        readingMonth: 'Reading Month',
        readingMonthPlaceholder: 'Select month',
        meterType: 'Meter Type',
        meterUsage: 'Usage',
        status: 'Status',
        keyword: 'Keyword',
        keywordPlaceholder: 'Meter code/shop/merchant',
        meterCode: 'Meter Code',
        meterName: 'Meter Name',
        shopName: 'Asset',
        merchantName: 'Merchant',
        previousReading: 'Previous',
        currentReading: 'Current',
        usageAmount: 'Usage',
        multiplier: 'Multiplier',
        unitPrice: 'Unit Price',
        feeAmount: 'Fee',
        readingSource: 'Source',
        sourceManual: 'Manual',
        sourceImport: 'Import',
        sourceAuto: 'Auto',
        isAbnormal: 'Abnormal',
        abnormalYes: 'Abnormal',
        abnormalNo: 'Normal',
        abnormalReason: 'Abnormal Reason',
        readingTime: 'Reading Time',
        reader: 'Reader',
        statusPending: 'Pending',
        statusConfirmed: 'Confirmed',
        statusFeeGenerated: 'Fee Generated',
        confirm: 'Confirm',
        generateFee: 'Generate Fee',
        calculateShare: 'Calculate Share',
        fillAbnormalReason: 'Fill Abnormal Reason',
        submitTitle: 'Submit Reading',
        importTitle: 'Import Readings',
        abnormalReasonTitle: 'Abnormal Reason',
        meter: 'Meter',
        meterPlaceholder: 'Select meter',
        currentReadingLabel: 'Current Reading',
        currentReadingPlaceholder: 'Enter current reading',
        readingTimePlaceholder: 'Select reading time',
        readerPlaceholder: 'Enter reader name',
        meterRequired: 'Please select a meter',
        currentReadingRequired: 'Please enter current reading',
        readingMonthRequired: 'Please select reading month',
        submitSuccess: 'Reading submitted successfully',
        confirmSuccess: 'Reading confirmed',
        batchConfirmSuccess: 'Batch confirmed successfully',
        generateFeeSuccess: 'Fee generated successfully',
        batchGenerateFeeSuccess: 'Batch fee generation successful',
        calculateShareSuccess: 'Share calculated, {count} merchants affected',
        importSuccess: '{success} imported, {fail} failed',
        abnormalReasonSuccess: 'Abnormal reason updated',
        selectRecords: 'Please select records to operate',
        onlyPendingCanConfirm: 'Only pending records can be confirmed',
        onlyConfirmedCanGenerate: 'Only confirmed records can generate fees',
        onlyPublicCanShare: 'Only public meter readings can calculate share',
        confirmConfirmMsg: 'Confirm this reading? It cannot be modified afterwards.',
        confirmTitle: 'Confirm Reading',
        generateFeeConfirmMsg: 'Confirm generating fee? It will be written to monthly fees.',
        generateFeeTitle: 'Generate Fee',
        calculateShareConfirmMsg: 'Confirm calculating share? Fees will be generated per sharing rules.',
        calculateShareTitle: 'Calculate Share',
      },
      price: {
        title: 'Price Configuration',
        addPrice: 'Add Price',
        editPrice: 'Edit Price',
        priceName: 'Price Name',
        priceNamePlaceholder: 'Enter price name',
        meterType: 'Meter Type',
        unitPrice: 'Unit Price',
        unitPricePlaceholder: 'Enter unit price',
        unit: 'Unit',
        unitPlaceholder: 'Enter unit',
        effectiveDate: 'Effective Date',
        effectiveDatePlaceholder: 'Select effective date',
        expireDate: 'Expire Date',
        expireDatePlaceholder: 'Select expire date (optional)',
        isDefault: 'Default',
        isDefaultYes: 'Yes',
        isDefaultNo: 'No',
        priceNameRequired: 'Please enter price name',
        meterTypeRequired: 'Please select meter type',
        unitPriceRequired: 'Please enter unit price',
        effectiveDateRequired: 'Please select effective date',
        saveSuccess: 'Price config saved successfully',
        deleteConfirm: 'Are you sure to delete this price config?',
        deleteSuccess: 'Price config deleted successfully',
      },
    },
  },
  // Report Center
  report: {
    leaseRate: {
      title: 'Lease Rate Analysis',
      // Overview cards
      totalLeasableArea: 'Total Leasable Area',
      leasedArea: 'Leased Area',
      vacantArea: 'Vacant Area',
      overallLeaseRate: 'Overall Lease Rate',
      // Chart titles
      floorLeaseRateChart: 'Lease Rate by Floor',
      businessTypeLeaseRateChart: 'Lease Rate by Business Type',
      targetLine: 'Target',
      // Detail table
      detailTable: 'Lease Rate Details',
      totalShops: 'Total Shops',
      leasedShops: 'Leased Shops',
      colTotalArea: 'Total Area (㎡)',
      colLeasedArea: 'Leased Area (㎡)',
      colVacantArea: 'Vacant Area (㎡)',
      colLeaseRate: 'Lease Rate',
      footerTotal: 'Total',
    },
  },
}
